import { Component, OnInit } from '@angular/core';
import { StorageService } from '../core/services/storage.service';
@Component({
  selector: 'app-error',
  templateUrl: './app-error.component.html',
  styleUrls: ['./app-error.component.scss']
})
export class AppErrorComponent implements OnInit {

  constructor(private storageService: StorageService) { 
    
  }

  content = this.storageService.resource?.landing;
  commonContent = this.storageService.resource?.commonContent;
  ngOnInit(): void {
  }

}
